import {ApiResource} from 'common/util/model-resource/api-resource';
import {DataGroup} from 'common/widgets/data-group-selector/types';

import {dataGroupsResourceClient} from '../queries/app-api/data-groups-client';

export class DataGroupsResource extends ApiResource<DataGroup> {
  apiClient = dataGroupsResourceClient;
}
